import React from 'react';

import { withRouter } from 'react-router';
import styled from 'styled-components';
import Crane from '../img/redox_build.svg';
import polyglot from '../Translator';

const Grid = styled.div`
	display: grid;
	grid-gap: 10px;
	padding-left: 20px;
	padding-right: 20px;
	grid-template-areas: 'img' 'paragraph';
	grid-template-rows: 1fr 2fr;

	@media (min-width: 450px) {
		grid-template-areas: 'img paragraph';
		grid-template-rows: 1fr;
		grid-template-columns: 1fr 1fr;
		height: calc(100vh - 65px);
	}
`;

const Image = styled.div`
	grid-area: img;
	display: flex;
	justify-content: center;
	align-items: center;
	text-align: center;
`;
const Paragraph = styled.div`
	grid-area: paragraph;
	display: flex;
	justify-content: center;
	align-items: center;
	text-align: center;
	flex-direction: column;
	font-weight: 400;
	font-size: 22px;
	text-justify: auto;
	@media (min-width: 450px) {
		width: 75%;
	}
`;
const MainTitle = styled.h1`
	font-weight: 300;
	font-size: 45px;
`;

// const translations = {
// 	aboutTitle: {
// 		en: 'Redox | About',
// 		fr: 'Redox | À propos'
// 	},
// 	aboutDescription: {
// 		en:
// 			'Our mission is to optimize the practice of professionals by democratizing the use of intelligent applications in the legal and accounting sector.',
// 		fr:
// 			"Notre mission est d’optimiser la pratique des professionnels en démocratisant l'utilisation d'applications intelligentes dans le secteur juridique et comptable."
// 	}
// };

function About() {
	return (
		<div>
			{/* <Helmet>
        <title>{polyglot.tr(translations.aboutTitle)}</title>
        <meta name="description" content={polyglot.tr(translations.aboutDescription)} />
        <meta name="keywords" content="Redox about,Automation tool for lawyers about,Redox a propos,Redox à propos" />
      </Helmet> */}

			<Grid>
				<Image>
					<img id="redoxBuild" style={{ width: '100%', height: 'auto' }} alt="" src={Crane} />
				</Image>
				<Paragraph>
					<MainTitle>{polyglot.t('aboutTitle')}</MainTitle>
					{polyglot.t('aboutP1')}
					<br />
					<br />
					{polyglot.t('aboutP2')}
					<a href="mailto:support@redox-technologies.ca">{'support@redox-technologies.ca'}</a>
				</Paragraph>
			</Grid>
		</div>
	);
}

export default withRouter(About);
